import { InfoCircleOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { BannerIcon, BannerWrapper } from '../sent/IntegrationBanner.tsx';

const { Text, Title } = Typography;

export interface ISubmissionDelegationBannerProps {}

/**
 * Banner di avviso in caso di richiesta delegata
 */
export function SubmissionDelegationBanner(
  props: ISubmissionDelegationBannerProps,
) {
  const { t } = useTranslation();

  return (
    <BannerWrapper>
      <Flex align="center" justify="center" gap={12}>
        <BannerIcon>
          <InfoCircleOutlined aria-label="Informazione" />
        </BannerIcon>
        <Text strong>
          {t(
            'submission.delegation-banner.stai-commpilando-in-delega-la-richiesta',
            'Stai compilando in delega questa richiesta.',
          )}
        </Text>
      </Flex>
    </BannerWrapper>
  );
}
